import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { navItems } from "../../_nav";
import { Router } from "@angular/router";
import { LocalStorageService } from "../../core/local-storage.service";
import { UserPermissionModel } from "../../components/user/shared/user.model";
import { UserProfileModel } from "../../components/profile/shared/profile.model";
import { ProfileService } from "../../components/profile/shared/profile.service";
import {
  PermissionsEnum,
  UserRole,
  UserPermissionsEnum,
  RoleEnum,
  ApplicationEnum,
} from "../../shared/enum/base.enum";
import { UserService } from "../../components/user/shared/user.service";
import { UserPermissionComponent } from "../../shared/user-permission/user-permission.component";
import {
  UnreadNotificationModel,
  UserNotificationDataModel,
  UserNotificationModel,
} from "../../views/login/login.model";
import { PaginationService } from "../../shared/pagination.service";
import { MessagingService } from "../../shared/services/messaging-service";
import { LoginService } from "../../views/login/login.service";

@Component({
  selector: "app-dashboard",
  templateUrl: "./default-layout.component.html",
  styleUrls: ["./default.layout.css"],
})
export class DefaultLayoutComponent
  extends UserPermissionComponent
  implements OnInit {
  public sidebarMinimized = false;
  public navItems: any;
  public newNotification = new UserNotificationModel();
  userPermissionList: Array<UserPermissionModel> = [];
  roleEnum = RoleEnum;
  count = 0;
  notificationCount: number = 0;
  showPreviousnotification: boolean;
  notification_token: string = "";
  currentUser: any;
  userId: number;
  startPage: number = 1;
  notifications: Array<UserNotificationModel> = [];
  todaysNotifications: Array<UserNotificationModel> = [];
  previousNotifications: Array<UserNotificationModel> = [];
  applicationEnum = ApplicationEnum;
  currentApplication = ApplicationEnum.logistic;
  totalRecords: number = 0;
  isUnreadOnly: boolean = null;
  isDownloading: boolean;
  showNotification: boolean;
  @ViewChild('dropdownContent', { static: true }) dropdownContent: ElementRef;
  @ViewChild('bellDropdown', { static: true }) bellDropdown: ElementRef;

  handleClick: boolean = false;
  showOnlyHealth: boolean = false;
  unreadNotification: UnreadNotificationModel = new UnreadNotificationModel();
  iconClass: string = 'fa fa-arrow-right';
  userProfile: UserProfileModel = new UserProfileModel();
  constructor(
    private router: Router,
    private messagingService: MessagingService,
    public localStorageService: LocalStorageService,
    private profileService: ProfileService,
    public userService: UserService,
    private paginationService: PaginationService,
    private loginService: LoginService
  ) {
    super(localStorageService, userService);
    this.validatePermission(UserPermissionsEnum.Welcome);
    if (this.user.role === UserRole.SubAdmin) {
      this.localStorageService.currentPermissions.subscribe((res) => {
        if (res.length > 0) {
          if (this.count === 0) {
            this.count++;
            this.retreiveNavItems();
            this.permissions = res;
            this.retreiveUserPermission();
            this.retreiveUnreadNotificationCount();
          }
        }
      });
    } else {
      this.retreiveNavItems();
      this.retreiveUnreadNotificationCount();
    }
    this.messagingService.currentMessage.subscribe((res) => {
      if (res) {
        // this.transferToNotificationModel(res);
        // this.todaysNotifications.push(this.newNotification);
        this.unreadNotification.unreadNotificationCount++;
        if (res.data["gcm.notification.appUId"] === ApplicationEnum.logistic) {
          this.unreadNotification.totalUnreadRideNotificationCount++;
        } else if (res.data["gcm.notification.appUId"] === ApplicationEnum.Health) {
          this.unreadNotification.totalUnreadHealthNotificationCount++;
        } else {
          this.unreadNotification.totalUnreadFoodNotificationCount++;

        }
      }
    });
    this.paginationService.setDefaultPage();
  }



  transferToNotificationModel(receivedMessage) {
    let data = receivedMessage.data;
    this.newNotification.appUId = data["gcm.notification.appUId"];
    this.newNotification.createdDateTime = data["gcm.notification.createdDateTime"];
    this.newNotification.isNotificationSent = data["gcm.notification.isNotificationSent"];
    this.newNotification.isReadNotification = data["gcm.notification.isReadNotification"];
    this.newNotification.notificationBody = data["gcm.notification.notificationBody"];
    this.newNotification.notificationHeader = data["gcm.notification.notificationKey"];
    this.newNotification.notificationPayload = data["gcm.notification.notificationPayload"];
    this.newNotification.payloadResult = data["gcm.notification.payloadResult"];
    this.newNotification.uId = data["gcm.notification.uId"];
    this.newNotification.userUId = data["gcm.notification.userUId"];
  }


  retreiveUnreadNotificationCount() {
    this.messagingService.getUnreadNotificationCount().subscribe((res: UnreadNotificationModel) => {
      if (res) {
        res.unreadNotificationCount = 0;
        if (this.showRideNotification) {
          this.currentApplication = ApplicationEnum.logistic;
          res.todaysNotification = res.rideTodayNotificationCount;
          res.previousNotification = res.ridePreviousNotificationCount;
        } else if (this.showHealthNotification) {
          this.currentApplication = ApplicationEnum.Health;
          res.todaysNotification = res.healthTodayNotificationCount;
          res.previousNotification = res.healthPreviousNotificationCount;
        } else if (this.showFoodNotification) {
          this.currentApplication = ApplicationEnum.Food;
          res.todaysNotification = res.foodTodayNotificationCount;
          res.previousNotification = res.foodPreviousNotificationCount;
        }
        this.showRideNotification ? res.unreadNotificationCount += this.getTotalUnreadCount(this.showRideNotification, ApplicationEnum.logistic, res) : '';
        this.showHealthNotification ? res.unreadNotificationCount += this.getTotalUnreadCount(this.showHealthNotification, ApplicationEnum.Health, res) : '';
        this.showFoodNotification ? res.unreadNotificationCount += this.getTotalUnreadCount(this.showFoodNotification, ApplicationEnum.Food, res) : '';

        // if ((this.user.email === HealthEditorMails.devServer || this.user.email === HealthEditorMails.testServer ||  this.user.email === HealthEditorMails.preServer) ) { 
        //   res.todaysNotification = res.healthTodayNotificationCount;
        //   res.previousNotification = res.healthPreviousNotificationCount;
        //   res.unreadNotificationCount = res.totalUnreadHealthNotificationCount;
        // } else {
        //   res.todaysNotification = res.rideTodayNotificationCount;
        // res.previousNotification = res.ridePreviousNotificationCount;
        // }
        this.unreadNotification = res;
      }
    });
  }

  getTotalUnreadCount(value, applicationType, data: UnreadNotificationModel) {
    if (value && applicationType === ApplicationEnum.logistic) {
      return data.totalUnreadRideNotificationCount
    } else if (value && applicationType === ApplicationEnum.Health) {
      return data.totalUnreadHealthNotificationCount

    } else if (value && applicationType === ApplicationEnum.Food) {
      return data.totalUnreadFoodNotificationCount
    }
  }

  retreiveNavItems() {
    this.navItems = navItems();
    this.navItems.forEach((res) => {
    //if(res.name!='Centro de reportes')
    //{
      res.name = this.localStorageService.getSelectedLanguageValue(
        "General." + res.name
      );

      if (res.children) {
        res.children.forEach((response) => {
          response.name = this.localStorageService.getSelectedLanguageValue(
            "General." + response.name
          );
        });
     // }
    }
    });
  }

  getNotifications() {
    this.handleClick = !this.handleClick;
    this.showNotification = !this.showNotification;
    document.getElementById("myDropdown").classList.toggle("show");
    this.notifications = [];
    this.todaysNotifications = [];
    this.previousNotifications = [];
    this.startPage = 1;
    this.isUnreadOnly = null;
    if (this.showNotification) {
      this.retreiveNotification();
    }
  }

  retreiveUnreadNotification() {
    this.isUnreadOnly = false;
    this.startPage = 1;
    this.totalRecords = 0;
    this.notifications = [];
    this.todaysNotifications = [];
    this.previousNotifications = [];
    this.retreiveNotification();
  }

  retreiveAllNotification() {
    this.isUnreadOnly = null;
    this.startPage = 1;
    this.totalRecords = 0;
    this.notifications = [];
    this.todaysNotifications = [];
    this.previousNotifications = [];
    this.retreiveNotification();
  }

  retreiveMoreNotification() {
    this.startPage++;
    this.retreiveNotification();
  }


  retreiveNotification() {
    const params = this.paginationService.getParams();
    params.StartPageNo = this.startPage;
    params.PageSize = 50;
    params['Filter.AppUId'] = this.currentApplication;
    this.isUnreadOnly === false ? params['Filter.IsUnreadOnly'] = this.isUnreadOnly : '';
    this.messagingService.getNotificationList(params).subscribe(
      (res: UserNotificationDataModel) => {
        if (res.data.length > 0) {
          if (res.data[0].appUId === this.currentApplication) {
            res.data.forEach(data => {
              const index = this.notifications.findIndex(notification => notification.uId === data.uId);
              if (index < 0) {
                this.notifications.push(data);
              }
            })
            this.totalRecords = res.totalRecords
            this.todaysNotifications = this.notifications.filter(notification => this.formatDate(notification.createdDateTime) === this.formatDate(new Date()));
            this.previousNotifications = this.notifications.filter(notification => this.formatDate(notification.createdDateTime) !== this.formatDate(new Date()));
          }

        }
      },
      (err) => { }
    );
  }

  retreiveApplicationNotification(value) {
    this.currentApplication = value;
    if (value === ApplicationEnum.logistic) {
      this.unreadNotification.todaysNotification = this.unreadNotification.rideTodayNotificationCount;
      this.unreadNotification.previousNotification = this.unreadNotification.ridePreviousNotificationCount;
    } else if (value === ApplicationEnum.Health) {
      this.unreadNotification.todaysNotification = this.unreadNotification.healthTodayNotificationCount;
      this.unreadNotification.previousNotification = this.unreadNotification.healthPreviousNotificationCount;
    } else {
      this.unreadNotification.todaysNotification = this.unreadNotification.foodTodayNotificationCount;
      this.unreadNotification.previousNotification = this.unreadNotification.foodPreviousNotificationCount;
    }
    this.notifications = [];
    this.todaysNotifications = [];
    this.previousNotifications = [];
    this.startPage = 1;
    this.totalRecords = 0;
    this.isUnreadOnly = null;
    this.retreiveNotification();
  }

  makeNotificationRead(obj) {
    const data = [obj.uId];
    window.open(obj.payloadResult.redirectUrl, "_self")
    document.getElementById("myDropdown").classList.toggle("show");
    this.showNotification = !this.showNotification;
    this.totalRecords = 0;
    if (!obj.isReadNotification) {
      this.messagingService.markNotificationAsRead(data).subscribe(
        (res: any) => {
          if (res) {
            obj.isReadNotification = true;
            this.unreadNotification.unreadNotificationCount--;
            if (this.currentApplication === ApplicationEnum.logistic) {
              this.unreadNotification.totalUnreadRideNotificationCount--;
            } else if (this.currentApplication === ApplicationEnum.Health) {
              this.unreadNotification.totalUnreadHealthNotificationCount--;

            } else {
              this.unreadNotification.totalUnreadFoodNotificationCount--;

            }
          }
        },
        (err) => { }
      );
    }

  }

  toggleMinimize() { }
  retreiveUserPermission() {
    let permissions = this.permissions;
    permissions = permissions
      ? permissions.filter((permission) => {
        return (
          permission.permissionName === PermissionsEnum.ViewAll &&
          permission.hasPermission
        );
      })
      : [];
    permissions.forEach((element) => {
      element.subModuleName = this.localStorageService.getSelectedLanguageValue(
        "General." + element.subModuleName
      );
    });
    this.navItems.forEach((res) => {
      if (res.children) {
        res.children.forEach((result) => {
          const index = permissions.findIndex(
            (i) => i.subModuleName.trim() === result.name.trim()
          );
          if (index < 0) {
            res.children = res.children.filter((i) => i.name !== result.name);
          }
        });
      } else {
        const index = permissions.findIndex(
          (i) => i.subModuleName.trim() === res.name.trim()
        );
        if (index < 0) {
          this.navItems = this.navItems.filter((i) => i.name !== res.name);
        }
      }
    });
    const navBarItems = this.navItems.map((obj) => ({ ...obj }));
    navBarItems.forEach((response) => {
      if (response.hasOwnProperty("children")) {
        if (response.children.length === 0) {
          const index = this.navItems.findIndex(
            (i) => i.name.trim() === response.name.trim()
          );
          this.navItems.splice(index, 1);
        }
      }
    });
  }

  ngOnInit() {
    this.userService.downloadProgress.subscribe(res => {
      this.isDownloading = res;
    });

    this.userService.profileUpdateEvent.subscribe((res) => {
      this.userProfile.profilePicURL = res.profilePicURL;
      this.userProfile.firstName = res.firstName;
      this.userProfile.lastName = res.lastName;
    });

    this.getUserProfile();
    // let container = document.getElementById('myDropdown');
    // let bellDropdown = document.getElementById('bellDropdown');
    const elmnt = this.dropdownContent.nativeElement;

    const elmtn1 = this.bellDropdown.nativeElement
    document.addEventListener('click', (event: any) => {
      const containerClicked = elmnt.contains(event.target);
      const bellIconClicked = elmtn1.contains(event.target);

      if (!containerClicked && !bellIconClicked) {
        if (elmnt.classList.contains('show')) {
          elmnt.classList.toggle("show");
          this.showNotification = false;
        }
      }
    });

  }

  retreivePreviousNotification() {
    this.showPreviousnotification = !this.showPreviousnotification;
    this.iconClass = this.showPreviousnotification ? 'fa fa-arrow-down' : 'fa fa-arrow-right';
  }




  getUserProfile() {
    this.profileService.getUserProfile().subscribe(
      (result: UserProfileModel) => {
        if (result) {
          this.userProfile = Object.assign({}, result);
        }
      },
      (err) => { }
    );
  }

  async logout() {

    this.notification_token = localStorage.getItem("notification_token");
    await this.loginService
      .removePushNotificationToken(this.notification_token)
      .subscribe((res) => {
        localStorage.removeItem("notification_token");
      });
    this.localStorageService.removeLogin();
    this.router.navigate(["login"]);
  }

  onClickNav(url) {
    this.router.navigate([url]);
  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }
}
